export default __webpack_public_path__ + "static/media/Yudi.9f76ed21.jpg";